export default __webpack_public_path__ + "static/media/m-link-blog.7c1c73a4.svg";